import { render } from "./ListContactsListing.vue?vue&type=template&id=898c9d26"
import script from "./ListContactsListing.vue?vue&type=script&lang=js"
export * from "./ListContactsListing.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__